import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleLoadingReportMasterList } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};



export const loadingReportMasterAsync=createAsyncThunk(
   "companyMaster/list",
   async ({ data, done, err }, thunkAPi) => {
      try {
         
         const { data: response } = await handleLoadingReportMasterList(data);
         if (response.statusCode === 200) {
            done && done(response.res);
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }

);

const loadingReportMasterListSlice = createSlice({
   name: "companyMaster",
   initialState,
   reducers: {

   },
   extraReducers: (builder) => {
      builder
         .addCase(loadingReportMasterAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(loadingReportMasterAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(loadingReportMasterAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});



export default loadingReportMasterListSlice.reducer;